import {Observable} from 'rxjs';
import {inject} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {UserService} from './user.service';
import {Logger} from '../logging/default-log.service';

/**
 * Custom interceptor, which makes sure to redirect the user to the login page,
 * if an ajax call resulted in an forbidden or unauthorized http status.
 *
 * @author Nick Groenewegen
 */
export const notAuthorizedInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const logger = inject(Logger);

    return next(req).pipe(tap(
        () => {},
        (event) => {
            if (event instanceof HttpErrorResponse) {
                const url = event.url;

                // TODO: Verwijder deze logger line als het ticket gesloten is.
                if (!url) {
                    logger.error('SUPNOVICOM-526', event);
                    return;
                }

                // Don't redirect if the 'login' call resulted in a 403.
                if (
                    url.indexOf('remotelogin') === -1 &&
                    (event.status === 401 || event.status === 403) &&
                    (window.location.href.match(/\?/g) || []).length < 2
                ) {
                    UserService.cleanupOldStorageValuesAndRedirectToLogin();
                }
            }
        }
    ));
};
